module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_14.00d4004b.pdf";